import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";

import { Transition } from "../../Modal/ModalConstants";
import Loader from "../Loader/Loader";
import { APP_BASE_URL, GET_ALL_CUSTOMER } from "../../Common/EndPoints";

const updateCustomer = async (id: string, body: any) => {
  let url = APP_BASE_URL + GET_ALL_CUSTOMER + `/${id}`;
  return axios.put(url, {}, { params: body });
};

type IProps = {
  onClose: (byCross?: boolean) => void;
  initialData: any;
};

const UpdateGeoFencing = ({ initialData, onClose }: IProps) => {
  const [loading, setLoading] = useState(false);
  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: {
      geotagging_restricted:
        initialData?.additionalDetail?.geotagging_restricted === false
          ? "Unrestricted"
          : initialData?.additionalDetail?.geotagging_restricted === true
          ? "Restricted"
          : null,
      geotagging_distance: initialData?.additionalDetail?.geotagging_distance || "",
    },
  });
  const geotagging_restricted = watch("geotagging_restricted");

  const onSubmit = async (data: any) => {
    const { geotagging_restricted, geotagging_distance } = data;
    try {
      setLoading(true);
      await updateCustomer(initialData.customerId, {
        divisioncode: initialData.divisionCode,
        zonecode: initialData.zoneCode,
        Customerjson: JSON.stringify({
          geotagging_restricted: geotagging_restricted === "Unrestricted" ? false : true,
          geotagging_distance: geotagging_restricted === "Unrestricted" ? null : geotagging_distance,
        }),
      });
      toast.success("Geo Restriction Updated Successfully!");
      onClose();
      setLoading(false);
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong! Try again later!");
        return;
      }
      toast.error(error?.message || "Something went wrong! Try again later!");
    }
  };

  return (
    <Dialog
      open
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition as any}
      onClose={(_e, reason) => {
        onClose(true);
      }}
    >
      {loading && <Loader fullScreen={true} />}
      <DialogTitle id="responsive-dialog-title" className="flex">
        Update Geo Restriction
        <CloseIcon className="pointer" sx={{ ml: "auto" }} onClick={() => onClose(true)} />
      </DialogTitle>

      <DialogContent dividers>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Controller
              control={control}
              name="geotagging_restricted"
              rules={{ required: "Select One of Geotagging Restriction Status" }}
              render={({ field: { ref, name, onBlur, onChange, value }, fieldState: { error, invalid } }) => (
                <Autocomplete
                  options={["Restricted", "Unrestricted"]}
                  ref={ref}
                  fullWidth
                  size="small"
                  className="filter-input auto-complete"
                  renderInput={(params) => (
                    <TextField
                      required
                      name={name}
                      className="filter-input"
                      {...params}
                      label="Select Geotagging Restriction Status"
                      placeholder="Select Geotagging Restriction Status"
                      error={!!invalid}
                      helperText={error?.message}
                    />
                  )}
                  onBlur={onBlur}
                  value={value || null}
                  onChange={(_, newValue) => {
                    onChange(newValue);
                    if (newValue === "Restricted") setValue("geotagging_distance", "100");
                    else setValue("geotagging_distance", "");
                  }}
                />
              )}
            />

            <Controller
              control={control}
              name="geotagging_distance"
              rules={{
                validate: (value) => {
                  if (geotagging_restricted === "Restricted" && !value) {
                    if (!value) return "Geo Tagging Distance is required";
                    if (value < 1) return "Minimum value is 1";
                  }
                  return true;
                },
              }}
              render={({ field, fieldState: { error, invalid } }) => (
                <TextField
                  {...field}
                  disabled={geotagging_restricted === "Unrestricted"}
                  required
                  fullWidth
                  size="small"
                  className="filter-input"
                  placeholder="Geotagging Distance(in meters)"
                  label="Geotagging Distance(in meters)"
                  error={!!invalid}
                  helperText={error?.message || "Default is 100m"}
                />
              )}
            />
          </Stack>
        </form>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSubmit(onSubmit)}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateGeoFencing;
